export default "__VITE_PUBLIC_ASSET__37c90a69__"